<template>
  <van-popup title="运费抵扣详情" closeable v-model="frightListVisible" round position="bottom" style="padding-top: 4px;">
    <div class="shet">
      <div class="lef">运费抵扣详情</div>
    </div>
    <div class="yun-div0">
      <div class="yun-div1" v-for="item in list" :key="item.userFrightCouponId">
        <div class="yun-div1-0">
          <div class="yun-div1-1">{{item.branchName}}</div>
          <div class="yun-div1-2">运费：￥{{item.frightPrice}}</div>
        </div>
        <div class="yun-div1-2-3">- ￥{{item.acliyFriPrice}}</div>
      </div>
    </div>
    <div class="zul">
      <div class="zfot" @click="frightListVisible = false">知道了</div>
    </div>
  </van-popup>
</template>
<script>
export default {
  name: "f-coupon-list-item-B",
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
      required: true 
    }
  },
  data() {
    return {
      frightListVisible: false
    };
  },
  methods: {
    
  },
  created() {
 
  },
  computed: {},
  components: { }
};
</script>
<style lang="less" scoped>
.shet {
  padding-top: 49px;
  text-align: center;
  .lef {
    font-size: 32px;
    color: 32px;
    text-align: center;
  }
}
.yun-div0 {
  padding: 83px 30px 0 30px;
  font-size: 24px;
  .yun-div1 {
    border-bottom: 1px solid #f2f2f2;
    padding-left: 30px;
    .yun-div1-0 {
      display: flex;
      margin-top: 39px;
      .yun-div1-1 {
        text-align: left;
        color: #333333;
        width: 50%;
      }
      .yun-div1-2 {
        width: 50%;
        text-align: right;
        .yun-div1-2-1 {
          color: #999999;
        }
      }
    }
    .yun-div1-2-3 {
      color: #ed3939;
      margin-top: 39px;
      text-align: right;
      margin-bottom: 43px;
    }
  }
}
.yun-div0 > div:last-child {
  border-bottom: 0;
}
.zli {
  padding: 27px 20px 10px 20px;
  background-color: #F7F7F7;
  overflow: scroll;
  max-height: 600px;
}
.zul {
  text-align: center;
  padding-bottom: 60px;
  padding-top: 30px;
  width: 100%;
  .zfot {
    margin-left: 30%;
    text-align: center;
    font-size: 32px;
    width: 299px;
    height: 75px;
    line-height: 75px;
    background: rgba(248, 213, 65, 1);
    border-radius: 38px;
    color: #000000;
  }
}
</style>
